export enum IotMapDisplayType {
  CLUSTER = 'CLUSTER',
  POINT = 'POINT',
  LINESTRING = 'LINESTRING'
}
